<template>
  <div class="home-about-item ad">
    <div class="home-item-left">
      <page-video-player :url="videoUrl" autoplay loop v-if="seen" />
    </div>
    <div class="home-item-right">
      <div class="brown-head">
        <editable-item page="home" item="animx-bhead" :loaded="storiesLoaded" />
      </div>
      <editable-item page="home" item="animx-ad" :loaded="storiesLoaded" />
      <div class="b-panel">
        <ix-router-link class="redlink" to="/animation">www.animationx.com</ix-router-link>
      </div>
    </div>
  </div>
</template>

<script>
import PageVideoPlayer from '@/components/video/PageVideoPlayer.vue'
import EditableItem from '@/components/editors/EditableItem.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'
import stg from '@/data/home-style-galleries.js'

export default {
  mixins: [ViewablePanel ],
  components: {
    PageVideoPlayer,
    EditableItem
  },
  data () {
    return {
      storiesLoaded: false,
      videoUrl: ''
    }
    
  },
  methods: {
    async init () {
      this.$k.fetchStories('home', () => {
        this.storiesLoaded = true
      })
      let galleryUrl = stg.getRandomGallery(true)
      this.videoUrl = 'mediastore/video' + galleryUrl + '.mp4'
    }
  },
  watch: {
    seen () {
      this.init()
    }
  }
}
</script>

<style>

</style>